(() => {
  if (window.ModiFitInspirationData) return;
  const types = ['Print', 'Embroidery', 'Print + Embroidery'];
  const safeImage = value => {
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.origin === location.origin) ? u.href : ''; }
    catch (_) { return ''; }
  };
  const load = async ({previewTheme = '', signal} = {}) => {
    const url = new URL(window.Shopify?.routes?.root || '/', location.origin);
    url.searchParams.set('view', 'inspiration-data');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const items = [], seen = new Set(); let page = 1;
    for (let request = 0; request < 100; request++) {
      url.searchParams.set('page', String(page));
      const response = await fetch(url, {signal, credentials: 'same-origin', headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Gallery data unavailable');
      const data = await response.json();
      if (data.version !== 3 || !Array.isArray(data.items) || data.page !== page) throw new Error('Invalid gallery data');
      for (const raw of data.items) {
        if (!raw.id || seen.has(raw.id)) throw new Error('Duplicate gallery entry');
        seen.add(raw.id);
        const photos = (raw.photos || []).map(p => ({...p, src: safeImage(p.src), thumb: safeImage(p.thumb)})).filter(p => p.src && p.thumb);
        if (!photos.length) continue;
        items.push({...raw, title: String(raw.title || raw.reference || raw.id), reference: String(raw.reference || raw.id), themes: Array.isArray(raw.themes) ? raw.themes : [], colours: Array.isArray(raw.colours) ? raw.colours : [], tags: Array.isArray(raw.tags) ? raw.tags : [], role: raw.role === 'collection' ? 'collection' : 'belt', designType: types.includes(raw.designType) ? raw.designType : '', photos});
      }
      if (data.nextPage === null) return {version: 3, items: items.sort((a,b) => Number(a.order) - Number(b.order) || a.reference.localeCompare(b.reference))};
      if (data.nextPage !== page + 1) throw new Error('Invalid gallery pagination');
      if (!/^page(?:_[a-z0-9]+)?$/.test(data.pageParam || '')) throw new Error('Invalid gallery page parameter');
      page = data.nextPage;
      url.searchParams.set(data.pageParam, String(page));
    }
    throw new Error('Gallery exceeds page limit');
  };
  window.ModiFitInspirationData = {load, types};
})();
